<script setup lang="ts">import { computed as _computed } from 'vue';

import type {Component} from 'vue'
import {defineProps, PropType} from 'vue'

import {PermissionEntityType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionEntityType'
import {PermissionEntityTypeThumbnailStrategyMap} from '../maps/PermissionEntityTypeThumbnailStrategyMap'

const props = defineProps({
  entityType: {
    type: String as PropType<PermissionEntityType>,
    required: true,
  },
  entityId: {
    type: String,
    required: true,
  },
  payload: {
    type: Object,
    required: true,
  },
})

const strategyComponent = _computed<Component>(() => {
  return PermissionEntityTypeThumbnailStrategyMap.get(props.entityType)
})
</script>

<template>
  <template v-if="strategyComponent">
    <Component :is="strategyComponent" :payload="payload" :entityId="entityId"/>
  </template>
</template>
